(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/assets/javascripts/helpers/common.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/assets/javascripts/helpers/common.js'); 'use strict';

var errorMessages = {
  failedWithAssetId: 'Failed to load video metadata for video with assetId',
  noAssetId: 'Video player called without an assetId, no video will be loaded.'
};

var getThumbnailFromResult = function getThumbnailFromResult(result) {
  var thumbnail;

  for (var i = 0; i < result.localized[0].images.length; i++) {
    if (result.localized[0].images[i].type === 'thumbnail') {
      thumbnail = result.localized[0].images[i];
      break;
    }
  }

  return thumbnail && thumbnail.url;
};


function durationFormater(milliseconds) {
  var seconds = Math.floor(milliseconds / 1000);
  var minutes = Math.floor(seconds / 60);
  return "PT".concat(minutes, "M").concat(seconds % 60, "S");
}


var getJsonLDString = function getJsonLDString(result) {
  try {
    return JSON.stringify({
      '@context': 'https://schema.org/',
      '@type': 'VideoObject',
      uploadDate: result.publications[0].publicationDate,
      description: result.localized[0].longDescription,
      duration: durationFormater(result.duration),
      name: result.localized[0].title,
      thumbnailUrl: getThumbnailFromResult(result)
    });
  } catch (err) {
    return null;
  }
};

svs.components.emp_video_player.helpers.common = {
  errorMessages: errorMessages,
  getJsonLDString: getJsonLDString,
  getThumbnailFromResult: getThumbnailFromResult
};
 })(window);